<template>
  <v-app-bar
    id="app-bar"
    app
    class="app-toolbar"
    :style="style"
    :height="height"
    fixed
    dark
  >
    <router-link
      class="toolbar-title headline text-uppercase"
      :to="routes.home"
    >
      <span class="title-accent">TRAVIS</span>
      <span class="font-weight-light">HENNING</span>
    </router-link>
    <v-spacer />
    <div v-if="!isMobile">
      <v-btn
        v-for="x in navItems"
        :key="x.title"
        class="mx-1"
        activeClass="selected"
        text
        rounded
        :to="x.to"
      >
        {{ x.title }}
      </v-btn>
    </div>
  </v-app-bar>
</template>

<script>
import { routes } from '@/router';
import navItems from '@/utils/nav';

export default {
  name: 'app-nav',
  props: {
    isMobile: { type: Boolean },
    offsetTop: { type: Number },
  },
  data: () => ({
    routes,
    navItems: navItems.slice(1),
  }),
  computed: {
    height() {
      return this.$vuetify.breakpoint.xsOnly ? '56px' : '72px';
    },
    style() {
      return {
        // backgroundColor: this.offsetTop > 0 ? '#424242' : '#ffffff00',
      };
    },
  },
};
</script>

<style lang="scss" scoped>
.app-toolbar {
  // max-width: 100vw;
  // background-color: transparent;
  padding: 0 48px !important;

  @media screen and (max-width: 767px) {
    padding: 0 !important;
  }

  .toolbar-title {
    color: inherit;
    text-decoration: inherit;
    outline: none;
  }

  .title-accent {
    color: #e76800;
  }

  .v-btn {
    font-size: 0.75rem;

    &.selected::before {
      color: #e76800;
    }
  }
}
</style>
